<template>
<div id="app">
  <loading-screen v-if="isloading"></loading-screen>
  <div id="bkg"></div>
  <div id="manu" class="main_menu">
    <div class="title_head">
      <router-link class="menu menu-home" v-bind:to="'/'">JANCARUS</router-link>
    </div>
    <div id="menu">
    <router-link class="menu mline three"  v-for="routes in links" v-bind:key="routes.id" :to="routes.page"  v-on:click.native="di_menu2(routes)">{{routes.text}}</router-link>
    <router-link class="menu menu-started" v-bind:to="'/getstarted'">Get Started</router-link>
  </div>
    <div id="hamburger" v-on:click="display_menu()">
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>


  <transition name="router-anim">
    <router-view />
  </transition>
  <footer id="footer">
    <div class="footmargin">

      <div class="col colum_1">
        <a href="https://jancarus.com/contact">
          <h3>Connect with Us</h3>
        </a>
        <a href="https://jancarus.com/contact" class="social_icon">
          <font-awesome-icon icon="envelope" size="2x"  /></a>
        <a href="https://instagram.com/jancarus" class="social_icon">
          <font-awesome-icon :icon="{ prefix: 'fab', iconName: 'instagram' }" size="2x"  /></a>
        <a href="https://twitter.com/JancarusToday" class="social_icon">
          <font-awesome-icon :icon="{ prefix: 'fab', iconName: 'twitter' }" size="2x"  /></a>
        <a href="https://join.skype.com/invite/GC7mxwYXNgOt" class="social_icon">
          <font-awesome-icon :icon="{ prefix: 'fab', iconName: 'skype' }" size="2x" /></a>
        <a href="" class="social_icon">
          <font-awesome-icon icon="phone" size="2x" /> </a>
      </div>
      <div class="col colum_2">
        <div class="socialmedia">

          <div id="mc_embed_signup">
            <form action="https://jancarus.us16.list-manage.com/subscribe/post?u=df25c931b66933f6e5d09a76a&amp;id=2540efc296" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank" novalidate>
              <div id="mc_embed_signup_scroll">
                <h2 class="mailchimp_head">Join our community</h2>
                <div class="indicates-required"><span class="asterisk">*</span> indicates required</div>
                <div class="mc-field-group">
                  <label class="mailemail" for="mce-EMAIL">Email Address <span class="asterisk">*</span>
                  </label>
                  <input type="email" value="" name="EMAIL" class="required email" id="mce-EMAIL">
                </div>
                <div id="mce-responses" class="clear">
                  <div class="response" id="mce-error-response" style="display:none"></div>
                  <div class="response" id="mce-success-response" style="display:none"></div>
                </div> <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
                <div style="position: absolute; left: -5000px;" aria-hidden="true"><input type="text" name="b_df25c931b66933f6e5d09a76a_2540efc296" tabindex="-1" value=""></div>
                <div class="clear"><input type="submit" value="Subscribe" name="subscribe" id="mc-embedded-subscribe" class="button"></div>
              </div>
            </form>
          </div>
          <!--End mc_embed_signup-->
        </div>
      </div>
      <div class="col colum_3">
        <p>©{{ new Date().getFullYear() }}

          Jancarus, LLC</p>
      </div>
    </div>
  </footer>
</div>
</template>
<script>
  var loader={ template: '<div id="loading">Jancarus...</div>'}
export default {
  name: 'app',
  components: {
      'loading-screen': loader
  },
  methods: {

		display_menu : function(){
			var body = document.getElementsByTagName('body')[0];
			(!body.classList.contains('display_menu')) ? body.classList.add('display_menu') : body.classList.remove('display_menu');
		},
    di_menu2(p){
      var body = document.getElementsByTagName('body')[0];
      body.classList.remove('display_menu');
    }
  },


  data (){
    return {
      links: [{
        id: 0,
        text: 'About',
        page: '/about'
      },
      {
        id: 1,
        text: 'Services',
        page: '/services'
      },
      {
        id: 2,
        text: 'Products',
        page: '/products'
      }
      ]
   }
  }
}
</script>

<style>
@import 'main.css';
.fa-envelope, .fa-instagram, .fa-twitter, .fa-skype, .fa-phone{
  color:#fff;
}
.fa-envelope:hover, .fa-instagram:hover, .fa-twitter:hover, .fa-skype:hover, .fa-phone:hover{
  color:#000;
}
</style>



// WEBPACK FOOTER //
// src/App.vue